import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useCallback, useState } from 'react';
import { getDayjs, getDayjsNow, ISODate } from '../../common/utils';

export const useShowPastYear = () => {
  const [showPastYear, setShowPastYear] = useState(true);

  const onChange = useCallback((e: CheckboxChangeEvent) => {
    setShowPastYear(e.target.checked);
  }, []);

  const hideOldRows = useCallback(
    (row: { executionDate: ISODate }) => {
      let hidden = false;
      if (showPastYear) {
        const hiddenBefore = getDayjsNow().startOf('date').add(-1, 'year');
        const executionDate = getDayjs(row.executionDate)?.startOf('date');
        hidden = executionDate?.isBefore(hiddenBefore) || false;
      }

      return { hidden };
    },
    [showPastYear]
  );

  return { showPastYear, onChange, hideOldRows };
};
